import {
  siSupabase,
  siOpenrouter,
  siGooglecloud,
  siVercel,
  siCursor,
  siGithubcopilot,
  siFramer,
  siReact,
  siReactrouter,
  siReactquery,
  siRadixui,
  siTailwindcss,
  siThreedotjs,
  siLucide,
  siPostgresql,
  siGithub,
  siShadcnui,
} from "simple-icons";

export const iconMap = {
  supabase: siSupabase,
  openrouter: siOpenrouter,
  googlecloud: siGooglecloud,
  vercel: siVercel,
  cursor: siCursor,
  githubcopilot: siGithubcopilot,
  framer: siFramer,
  react: siReact,
  reactrouter: siReactrouter,
  reactquery: siReactquery,
  radixui: siRadixui,
  tailwindcss: siTailwindcss,
  threedotjs: siThreedotjs,
  lucide: siLucide,
  postgresql: siPostgresql,
  github: siGithub,
  shadcnui: siShadcnui,
} as const;

export type SimpleIconSlug = keyof typeof iconMap;

export interface BrandIconProps {
  slug?: SimpleIconSlug;
  className?: string;
}

export function BrandIcon({ slug, className }: BrandIconProps) {
  if (!slug || !iconMap[slug]) return null;
  const icon = iconMap[slug];
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      role="img"
      aria-label={icon.title}
    >
      <path d={icon.path} fill={`#${icon.hex}`} />
    </svg>
  );
}
